import { render, staticRenderFns } from "./MeasureUnitList.vue?vue&type=template&id=33e55dea"
import script from "./MeasureUnitList.vue?vue&type=script&lang=js"
export * from "./MeasureUnitList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports